import React from 'react';
import {connect} from "react-redux";
import {Button, Card, Col, Form, Input, Row} from "antd";
import language from "../../languages/language";
import getTemplates from "../../actions/getTemplates";
import {addUpButton, renderTemplates} from "../../Helpers/utils";
import putTemplates from "../../actions/putTemplates";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import isLoggedIn from "../../actions/isLoggedIn";

class Templates extends React.Component
{
    state={ids:[]};

    componentDidMount()
    {
        this.props.isLoggedIn();
    }

    putTemplates=(formValues)=>
    {
        formValues.ids=this.state.ids;
        this.props.putTemplates({...formValues,...this.props.info});
    };

    renderPDFTemplates=()=>
    {
        const templates=addUpButton(this.state.parentId,this.props.info.parentId,this.props.info.templates);
        const title=language[this.props.language].advSelectTemplate + this.props.info.mail;
        return renderTemplates(title,templates,this.onCheckTemplate,this.enterCallBack,this.upCallBack,8,this.state.ids);
    };

    upCallBack =() =>
    {
        const parentId=this.props.parentId;
        const newValues={...this.props.info};
        newValues.parentId=parentId;
        this.setState({parentId:parentId},()=>this.props.getTemplates(newValues));
    };

    enterCallBack=(parentId)=>
    {
        const newValues={...this.props.info};
        newValues.parentId=parentId;
        this.setState({parentId:parentId},()=>this.props.getTemplates(newValues));
    };

    onCheckTemplate=(id,checked)=>
    {
        if(checked)
            this.setState({ids:[...this.state.ids,id]});
        else
            this.setState({ids: this.state.ids.filter(item => item !== id)});
    };

    render()
    {
        const span=24;
        return <Card title={language[this.props.language].advSentToMenu} bordered={false}>
            <Form ref={this.formRef} onFinish={this.putTemplates} className={'regularForm'}>
                <Col span={span}>
                    <Form.Item name="manager"
                               rules={[{required: true,
                                   message: language[this.props.language].requiredError }]}>
                        <Input placeholder={language[this.props.language].advCoordLabel}
                               size={'large'} className={'mb-10'}
                               prefix={<UserOutlined style={{color: 'rgba(0,0,0,.25)'}} />}/>
                    </Form.Item>
                </Col>
                <Col span={span}>
                    {this.renderPDFTemplates()}
                </Col>
                <Col span={span}>
                    <Form.Item name="comment">
                        <Input.TextArea showCount={true} maxLength={200}
                            placeholder={language[this.props.language].advCommentLabel}/>
                    </Form.Item>
                </Col>
                <Row justify={'center'}>
                    <Col span={span}>
                        <Form.Item className={'text-center'}>
                            <Button type="primary light-blue rounded" htmlType="submit">
                                {language[this.props.language].advSendToButtonLabel}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>;
    }
}
function mapStateToProps(state) {
    return {
        language: state.auth.language,
        info:state.info
    }
}
export default connect(mapStateToProps, {getTemplates,putTemplates,isLoggedIn})(Templates);